<script lang="ts" setup>
import {
  getPhaseStatusColor,
  getTerminStatusColor,
  getTerminStatusBorder,
  getPhaseStatusBorder,
} from "@/utils/status-color";
import { ref, defineProps, defineEmits } from "vue";

type Props = {
  statusId: number;
  statusName: string;
  isTermin: boolean;
};

type Emits = {
  (event: "refresh"): void;
};

const props = defineProps<Props>();
defineEmits<Emits>();

const isTooltipOpen = ref(false);
</script>
<template>
  <div class="relative">
    <!-- Tooltip -->
    <div
      v-if="isTooltipOpen"
      class="absolute top-[-40px] left-[-120px] w-[250px]"
    >
      <div class="flex flex-col items-center">
        <div class="p-2 rounded-lg bg-[#393840] text-white text-xs font-medium">
          {{ statusName }}
        </div>
        <svg
          width="10"
          height="4"
          viewBox="0 0 10 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0H0L4.37531 3.50024C4.74052 3.79242 5.25948 3.79242 5.62469 3.50024L10 0Z"
            fill="#393840"
          />
        </svg>
      </div>
    </div>
    <!-- Dot -->
    <div
      @mouseenter="isTooltipOpen = true"
      @mouseleave="isTooltipOpen = false"
      class="flex relative"
    >
      <span
        v-if="isTermin"
        class="rounded border w-2 h-2"
        :style="{
          borderColor: `${getTerminStatusBorder(statusId)}`,
          backgroundColor: `${getTerminStatusColor(statusId)}`,
        }"
      ></span>
      <span
        v-else
        class="rounded border w-2 h-2"
        :style="{
          borderColor: `${getPhaseStatusBorder(statusId)}`,
          backgroundColor: `${getPhaseStatusColor(statusId)}`,
        }"
      ></span>
    </div>
  </div>
</template>
